import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-testUpload',
  templateUrl: './testUpload.component.html',
  styleUrls: ['./testUpload.component.css']
})
export class TestUploadComponent implements OnInit {

	progress: number;
    message: string;
    baseUrl: string;

    @Output() public onUploadFinished = new EventEmitter();

    constructor(
        private http: HttpClient,
        
    ) {
        this.baseUrl = document.getElementsByTagName('base')[0].href;
    }

    ngOnInit() {
    }

    public uploadFile = (files) => {
        if (files.length === 0) {
            return;
        }

        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        //formData.append('file', fileToUpload, fileToUpload.name);

        //UploadByte
        //'https://localhost:44390/api/Upload' con  'UploadByte' or 'UploadProfilePicture' o 'UploadMultiplesProfilePicture'

        this.http.post(this.baseUrl +'api/Upload', formData,{ reportProgress: true, observe: 'events' })
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress)
                    this.progress = Math.round(100 * event.loaded / event.total);
                else if (event.type === HttpEventType.Response) {
                    this.message = 'Upload success.';
                    this.onUploadFinished.emit(event.body);
                }
            });
    }

	public uploadFileConLimite = (files) => {
        if (files.length === 0) {
            return;
        }

        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        //formData.append('file', fileToUpload, fileToUpload.name);

        //UploadByte
        //'https://localhost:44390/api/Upload' con  'UploadByte' or 'UploadProfilePicture' o 'UploadMultiplesProfilePicture'

        this.http.post(this.baseUrl +'api/Upload/limit', formData,{ reportProgress: true, observe: 'events' })
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress)
                    this.progress = Math.round(100 * event.loaded / event.total);
                else if (event.type === HttpEventType.Response) {
                    this.message = 'Upload success.';
                    this.onUploadFinished.emit(event.body);
                }
            });
    }

}
